import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, map } from 'rxjs';
import { BackendResponse } from '../../types/interfaces';
import { ConfigService } from '../config';
import { deserializeResponse } from './helpers';

interface SuggestionsParams<T> {
  query?: string;
  clazz: new () => T;
}

@Injectable({
  providedIn: 'root',
})
export class SuggestionsService {
  constructor(
    private http: HttpClient,
    private configService: ConfigService
  ) {}

  getSuggestions<T>(
    params: SuggestionsParams<T>
  ): Observable<BackendResponse<T>> {
    const url = this.configService.endpoints.suggestions;
    return this.http
      .get<BackendResponse<T>>(url, {
        params: { query: params.query || '' },
      })
      .pipe(map(response => deserializeResponse<T>(response, params.clazz)));
  }
}
